import React from "react";
import "../Tickets/Tickets.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setTicketData } from "../../../Redux/Actions/TechAppAction";
import { toast } from "react-toastify";

const AnnouncementCard = ({ announcement, index }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const openMessage = (index) => {
    dispatch(setTicketData(index));
    navigate("/techapp/view-ticket");
  };

  return (
    <div
      key={index}
      style={
        announcement.readed === false
          ? { border: "1px solid #fcc603" }
          : { border: "1px solid rgb(200,200,200)" }
      }
      onClick={() => {
        if (!localStorage.getItem("auth_from_admin")) {
          openMessage(announcement);
        } else {
          toast.error("شما از پنل ادمین وارد شده اید و دسترسی ندارید.");
        }
      }}
      className={`techapp-ticket-item  ${
        announcement.readed === true ? "readed" : ""
      }`}
    >
      <span className="techapp-ticket-item-title">{announcement.title}</span>
      <span className="techapp-ticket-item-text">
        {announcement.short_body}
      </span>
    </div>
  );
};
export default AnnouncementCard;
